import { toast } from "react-toastify";
import formErrorsHandler, { formErrorLoading } from "api/global/form-errors-handler";
import defaultErrorHandler from "api/global/default-error-handler";
import {
    getPromptKeys,
    getPromptByKey,
    updatePrompt
} from "api/menu/hr/prompts/requests";

export const PROMPTS_REQUEST_LOADING = "PROMPTS_REQUEST_LOADING";
export const PROMPTS_REQUEST_ERRORS = "PROMPTS_REQUEST_ERRORS";
export const FETCH_PROMPT_KEYS_SUCCESS = "FETCH_PROMPT_KEYS_SUCCESS";
export const FETCH_PROMPT_BY_KEY_SUCCESS = "FETCH_PROMPT_BY_KEY_SUCCESS";

export const setLoading = () => ({ type: PROMPTS_REQUEST_LOADING });

export const fetchPromptKeys = () => dispatch => {
    dispatch(setLoading());
    getPromptKeys()
        .then(response => {
            dispatch({ type: FETCH_PROMPT_KEYS_SUCCESS, payload: response.data });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, PROMPTS_REQUEST_ERRORS));
        });
};

export const fetchPromptByKey = (key) => dispatch => {
    dispatch(setLoading());
    getPromptByKey(key)
        .then(response => {
            dispatch({ type: FETCH_PROMPT_BY_KEY_SUCCESS, payload: response.data });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, PROMPTS_REQUEST_ERRORS));
        });
};

export const updatePromptByKey = (key, data, callback = false) => dispatch => {
    dispatch(formErrorLoading());
    updatePrompt(key, data)
        .then(() => {
            dispatch(formErrorLoading(false));
            toast(`Prompt "${key}" updated successfully`, { type: toast.TYPE.SUCCESS });
            if (callback) callback(true);
        })
        .catch(error => {
            dispatch(formErrorsHandler(error));
        });
};

export const clearPrompts = () => dispatch => {
    dispatch({ type: FETCH_PROMPT_KEYS_SUCCESS, payload: [] });
};

export const clearSinglePrompt = () => dispatch => {
    dispatch({ type: FETCH_PROMPT_BY_KEY_SUCCESS, payload: {} });
};
